export default "__VITE_ASSET__BXiGMUFV__"